const toDateInputValue = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export function getLastYearDateRange(today = new Date()) {
  const start = new Date(today);
  start.setFullYear(today.getFullYear() - 1);
  if (start.getMonth() !== today.getMonth()) start.setDate(0);

  const end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return { startDate: toDateInputValue(start), endDate: toDateInputValue(end) };
}
